module.exports = __webpack_public_path__ + "static/media/mkb.4773d828.png";